const mapExperiences = [
  {
    id: 1,
    year: "2023",
    backgroundChip: "#D8B4FE",
    color: "#7E22CE",
    title: "Ritnner Odontologia - Auxiliar de Saúde Bucal",
    description:
      "Atendimento ao público, organização de ambiente clínico e apoio em procedimentos, desenvolvendo habilidades de responsabilidade, comunicação e trabalho em equipe.",
  },
  {
    id: 2,
    year: "2024",
    backgroundChip: "#BFDBFE",
    color: "#1E40AF",
    title: "AgBe Soluções LTDA - Estágio em Front-End",
    description:
      "Atuação com PHP, JavaScript e Vue.js no desenvolvimento e manutenção de sistemas web.",
  },
  {
    id: 3,
    year: "Atual",
    backgroundChip: "#FEF3C7",
    color: "#92400E",
    title: "Projetos Open Source",
    description:
      "Contribuições utilizando TypeScript, JavaScript e Tailwind CSS, com foco em melhorias de código e resolução de bugs.",
  },
  {
    id: 4,
    year: "Atual",
    backgroundChip: "#FCE7F3",
    color: "#910a67",
    title: "ProBrain - Estágio em Front-End",
    description:
      "Desenvolvimento de interfaces com JavaScript, React, TypeScript, MUI e Ant Design, focando em componentização e boas práticas.",
  },
];
export default mapExperiences;
